// CDN Configuration
export const CDN_CONFIG = {
  // Primary CDN for optimized delivery
  primaryCDN: 'https://cdn.mediamogulz.de',
  
  // Fallback CDN for redundancy
  fallbackCDN: 'https://assets.mediamogulz.de',
  
  // Image optimization settings
  imageOptimization: {
    quality: 85,
    formats: ['avif', 'webp', 'jpg'],
    breakpoints: [320, 640, 1024, 1920, 2560],
    lazyLoading: true,
    placeholder: 'blur'
  },
  
  // Video optimization settings
  videoOptimization: {
    formats: ['webm', 'mp4'],
    codecs: {
      webm: ['vp9', 'vp8'],
      mp4: ['av01', 'hvc1', 'avc1']
    },
    qualities: ['4k', '1080p', '720p'],
    preload: 'metadata',
    autoplay: true,
    muted: true,
    loop: true
  },
  
  // Performance settings
  performance: {
    enableServiceWorker: true,
    cacheStrategy: 'stale-while-revalidate',
    maxAge: 31536000, // 1 year in seconds
    enableBrotli: true,
    enableGzip: true
  }
};

// Network-aware loading configuration
export const NETWORK_CONFIG = {
  // Connection type thresholds
  slowConnection: ['slow-2g', '2g'],
  moderateConnection: ['3g'],
  fastConnection: ['4g', '5g'],
  
  // Quality adjustments based on connection
  qualityByConnection: {
    'slow-2g': 'low',
    '2g': 'low',
    '3g': 'medium',
    '4g': 'high',
    '5g': 'ultra'
  },
  
  // Save data mode adjustments
  saveDataMode: {
    disableAutoplay: true,
    lowerQuality: true,
    reduceAnimations: true,
    compressImages: true
  }
};

// Browser support detection
export const BROWSER_SUPPORT = {
  avif: 'image/avif',
  webp: 'image/webp',
  jxl: 'image/jxl',
  webm: 'video/webm',
  mp4: 'video/mp4',
  
  // Codec support
  codecs: {
    vp9: 'video/webm; codecs="vp9"',
    vp8: 'video/webm; codecs="vp8"',
    av1: 'video/mp4; codecs="av01"',
    hevc: 'video/mp4; codecs="hvc1"',
    h264: 'video/mp4; codecs="avc1"'
  }
};

// Development vs Production configuration
export const ENV_CONFIG = {
  isDevelopment: process.env.NODE_ENV === 'development',
  isProduction: process.env.NODE_ENV === 'production',
  
  // Enable debug logging in development
  enableDebugLogging: process.env.NODE_ENV === 'development',
  
  // Use local assets in development fallback
  useLocalAssets: process.env.NODE_ENV === 'development',
  
  // Performance monitoring
  enablePerformanceMonitoring: process.env.NODE_ENV === 'production'
};
